import { STAGES, STAGE_LABEL, fmt, type EquipmentResult } from "@h2lca/core";
import { Bar, BarChart, CartesianGrid, Cell, LabelList, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import { CHART_LAYOUT, css, STAGE_COLOR } from "@/lib/design";
import { ChartTip } from "./ChartTip";

/** 설비별 배출량 가로 막대 , 경계 안 설비만, 큰 순서, 단계색. 범례는 아래 */
export function EquipmentBarChart({ byEquipment }: { byEquipment: EquipmentResult[] }) {
  const data = byEquipment
    .filter((e) => e.inBoundary)
    .sort((a, b) => b.kgCO2eq - a.kgCO2eq)
    .map((e) => ({ id: e.equipmentId, stage: e.stage, name: e.name, kgCO2eq: e.kgCO2eq, share: e.share }));
  if (data.length === 0) return <p className="text-footnote text-ink-subtle">경계 안 설비가 없습니다.</p>;
  const used = STAGES.filter((s) => data.some((d) => d.stage === s));
  return (
    <div>
      <div className="ws-chart w-full" style={{ height: data.length * CHART_LAYOUT.equipmentRow + CHART_LAYOUT.equipmentHeightPad }}>
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={data} layout="vertical" margin={{ top: CHART_LAYOUT.reportBarPad, right: CHART_LAYOUT.equipmentRightMargin, left: 0, bottom: 0 }} barCategoryGap="25%">
            <CartesianGrid horizontal={false} />
            <XAxis type="number" tickLine={false} axisLine={false} tickFormatter={(v: number) => fmt(v, 0)} />
            <YAxis type="category" dataKey="name" width={CHART_LAYOUT.equipmentLabelWidth} tickLine={false} axisLine={false} interval={0} />
            <Tooltip content={<ChartTip />} cursor={{ fill: css("--color-surface-sunken") }} />
            <Bar dataKey="kgCO2eq" maxBarSize={CHART_LAYOUT.equipmentBarMax} radius={[0, CHART_LAYOUT.equipmentBarRadius, CHART_LAYOUT.equipmentBarRadius, 0]} isAnimationActive={false}>
              {data.map((d) => (
                <Cell key={d.id} fill={css(STAGE_COLOR[d.stage].fill)} />
              ))}
              <LabelList dataKey="kgCO2eq" position="right" formatter={(v: unknown) => fmt(Number(v))} />
            </Bar>
          </BarChart>
        </ResponsiveContainer>
      </div>
      <div className="chart-legend" aria-label="범례">
        {used.map((s) => (
          <span key={s} className="inline-flex items-center gap-label">
            <span className="chart-legend-dot" style={{ backgroundColor: css(STAGE_COLOR[s].fill) }} />
            {STAGE_LABEL[s]}
          </span>
        ))}
      </div>
    </div>
  );
}
